import React, { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { MdSearch } from "react-icons/md";
import { ArrowDropDown, ArrowDropUp } from "@mui/icons-material";
import { useDispatch, useSelector } from "react-redux";
import {
  fetchWorkEntries,
  fetchWorkEntriesProjectTracking,
} from "../../../../store/slices/workentriesSlice";
import {
  fetchDescriptionTasks,
  fetchDescriptionTasksProjectTracking,
} from "../../../../store/slices/DescriptionTask";
import {
  fetchHardwareDescriptions,
  fetchHardwareProjectTracking,
} from "../../../../store/slices/hardwareDescriptionSlice";
import { fetchEmployees } from "../../../../store/slices/employeeSlice";
import AdminLoader from "../../../../components/common/loader/AdminLoader";
import { fetchAllProjects } from "../../../../store/slices/projectsSlice";
import ShowCompletedTasksOP from "./ShowCompletedTasksOP";
import { fetchLeads } from "../../../../store/slices/leadsSlice";
import FileUploadOP from "../FileUploadOP";
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import { setPersonReadTrue } from "../../../../store/slices/readSlice";
import DateConversion from "../../../../utils/DateConversion";
import { fetchGroups } from "../../../../store/slices/groupSlice";
import { getMyTrainings } from "../../../../store/slices/MyTraining/myTrainings";

const ProjectCompletedOpDash = ({ completeOpProjects, handlerefresh, isViewOnly = false }) => {
  const dispatch = useDispatch();
  const { formatDateByCountry } = DateConversion();
  const { employees } = useSelector((state) => state.employees);

  const { projectTrackingWorkEntries } = useSelector(
    (state) => state.workentries
  );
  const { hardwareProjectTracking } = useSelector(
    (state) => state.hardwareDescription
  );
  const { descriptionProjectTracking } = useSelector(
    (state) => state.descriptionTasks
  );
  const { leads } = useSelector((state) => state.leads);
  const { group: groups } = useSelector((state) => state.group);
  const LoggedUser = localStorage.getItem("email");

  const groupNameById = useMemo(() => {
    const map = new Map();
    (groups || []).forEach((g) => {
      const id = g?._id || g?.id;
      const name =
        g?.newGroupName || g?.groupname || g?.groupName || g?.name || "";
      if (id && name) map.set(String(id), name);
    });
    return map;
  }, [groups]);

  const getDisplayGroupName = useCallback(
    (projectRow) => {
      if (typeof projectRow?.group === "string" && projectRow.group.trim()) {
        return projectRow.group;
      }

      const directGroupName =
        projectRow?.group?.newGroupName ||
        projectRow?.group?.groupname ||
        projectRow?.group?.groupName ||
        projectRow?.group?.name ||
        projectRow?.groupid?.newGroupName ||
        projectRow?.groupid?.groupname ||
        projectRow?.groupid?.groupName ||
        projectRow?.groupid?.name ||
        projectRow?.groupId?.newGroupName ||
        projectRow?.groupId?.groupname ||
        projectRow?.groupId?.groupName ||
        projectRow?.groupId?.name ||
        projectRow?.lead?.groupid?.newGroupName ||
        projectRow?.lead?.groupid?.groupname ||
        projectRow?.lead?.groupid?.groupName ||
        projectRow?.lead?.groupid?.name ||
        projectRow?.lead?.groupId?.newGroupName ||
        projectRow?.lead?.groupId?.groupname ||
        projectRow?.lead?.groupId?.groupName ||
        projectRow?.lead?.groupId?.name;

      if (directGroupName) return directGroupName;

      const groupId =
        projectRow?.group?._id ||
        projectRow?.group?.id ||
        projectRow?.group ||
        projectRow?.groupid?._id ||
        projectRow?.groupid?.id ||
        projectRow?.groupid ||
        projectRow?.groupId?._id ||
        projectRow?.groupId?.id ||
        projectRow?.groupId ||
        projectRow?.lead?.groupid?._id ||
        projectRow?.lead?.groupid?.id ||
        projectRow?.lead?.groupid ||
        projectRow?.lead?.groupId?._id ||
        projectRow?.lead?.groupId?.id ||
        projectRow?.lead?.groupId;

      if (groupId && groupNameById.has(String(groupId))) {
        return groupNameById.get(String(groupId));
      }

      return projectRow?.AssignedGroup || "";
    },
    [groupNameById]
  );

  useEffect(() => {
    dispatch(fetchWorkEntriesProjectTracking());
    dispatch(fetchDescriptionTasksProjectTracking());
    dispatch(fetchHardwareProjectTracking());
    dispatch(fetchLeads());
    dispatch(fetchGroups());

    dispatch(fetchWorkEntries());
    dispatch(fetchHardwareDescriptions());
    dispatch(fetchDescriptionTasks());
    dispatch(fetchEmployees());
    dispatch(fetchAllProjects());
    dispatch(getMyTrainings());
  }, [dispatch]);
  const [isLoading] = useState(false);

  const [sortedProjects, setSortedProjects] = useState([]);

  useEffect(() => {
    setSortedProjects(completeOpProjects);
  }, [completeOpProjects]);

  const itemsPerPage = 10; // or any number of rows you want per page
  const [currentPage, setCurrentPage] = useState(1);

  const [searchQuery, setSearchQuery] = useState("");

  const handleSearchInputChange = (e) => {
    const query = e.target.value;
    setSearchQuery(query);
    setCurrentPage(1);
    filterLeadReports(query);
  };

  const totalItems = sortedProjects?.length;
  const totalPages = Math.ceil(totalItems / itemsPerPage);

  const startIdx = (currentPage - 1) * itemsPerPage;
  const endIdx = startIdx + itemsPerPage;
  const paginatedProjects = sortedProjects?.slice(startIdx, endIdx);


  const filterLeadReports = (query) => {
    const lowerCaseQuery = query.toLowerCase().trim();

    const filtered = completeOpProjects.filter((LeadReport) =>
      (getDisplayGroupName(LeadReport) || "")
        .toString()
        .trim()
        .toLowerCase()
        .includes(lowerCaseQuery) ||
      Object.entries(LeadReport).some(([key, value]) => {
        // Skip these keys
        if (
          key === "Assignedperson" ||
          key === "TypeService" ||
          key === "SalesPersonName" ||
          key === "SalesPersonEmail" ||
          key === "ResourceType" ||
          key === "QuotedValue" ||
          key === "ProjectManagerStatus" ||
          key === "ProjectManagerAction" ||
          key === "createdAt" ||
          key === "updatedAt" ||
          key === "PrimaryResources"
        )
          return false;

        if (value === null || value === undefined) return false;
        if (key === "DateRequested" || key === "ProjectDueDate") {
          const formattedDate = formatDateByCountry(value);  // ← change here
          return formattedDate.toLowerCase().includes(lowerCaseQuery);
        }

        // Handle all other fields
        const formattedValue = value.toString().trim().toLowerCase();
        return formattedValue.includes(lowerCaseQuery);
      })
    );

    setSortedProjects(filtered);
  };

  const sortAlphabetically = (targetToSort, order) => {
    const key = `${targetToSort}-${order}`;
    let sorted = [...sortedProjects]; // Always sort from the filtered dataset

    const compareStrings = (a, b) => {
      const valA = (a || "").toString().toLowerCase();
      const valB = (b || "").toString().toLowerCase();
      return valA.localeCompare(valB);
    };
    // Helper function for date comparison
    const compareDates = (a, b) => {
      const dateA = a ? new Date(a) : null;
      const dateB = b ? new Date(b) : null;

      if (!dateA && !dateB) return 0;
      if (!dateA) return 1;
      if (!dateB) return -1;

      return dateA - dateB;
    };

    switch (key) {
      case "AssignedGroup-az":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(a), getDisplayGroupName(b))
        );
        break;
      case "AssignedGroup-za":
        sorted.sort((a, b) =>
          compareStrings(getDisplayGroupName(b), getDisplayGroupName(a))
        );
        break;
      case "ProjectName-az":
        sorted.sort((a, b) => compareStrings(a.ProjectName, b.ProjectName));
        break;
      case "ProjectName-za":
        sorted.sort((a, b) => compareStrings(b.ProjectName, a.ProjectName));
        break;
      case "DateRequested-az":
        sorted.sort((a, b) => compareDates(a.DateRequested, b.DateRequested));
        break;
      case "DateRequested-za":
        sorted.sort((a, b) => compareDates(b.DateRequested, a.DateRequested));
        break;
      case "ProjectDueDate-az":
        sorted.sort((a, b) => compareDates(a.ProjectDueDate, b.ProjectDueDate));
        break;
      case "ProjectDueDate-za":
        sorted.sort((a, b) => compareDates(b.ProjectDueDate, a.ProjectDueDate));
        break;
      default:
        // Default to original filtered order
        sorted = [...sortedProjects];
        break;
    }

    setSortedProjects(sorted);
    setCurrentPage(1); // Reset to first page after sorting
  };

  const [loggedEmp, setLoggedEmp] = useState({})

  useEffect(() => {
    const EmailLocal = localStorage.getItem("email")
    const emp = employees.find((emp) => emp.EmpEmail === EmailLocal)
    setLoggedEmp(emp)
  }, [employees])

  const [rowId, setRowId] = useState(null)
  const [showListState, setShowListState] = useState("tasktable")
  const [clickedProject, setClickedProject] = useState(null);

  const ProjectCompleteOpref = useRef(null);
  useEffect(() => {
    if ((rowId)) {
      // Scroll to the right end of the container
      const scrollToPosition = ProjectCompleteOpref.current.scrollWidth;
      ProjectCompleteOpref.current.scrollTo({
        left: scrollToPosition,
        behavior: 'smooth'
      });
    }
  }, [rowId]);


  const handleleadread = async (row) => {
    const email = localStorage.getItem("email"); // "yapew30764@miracle3.com"
    const currentEmployee = employees.find((emp) => emp.EmpEmail === email);
    const isUserAssigned = row.Assignedperson?.find(
      person => person.email === email // replace with your actual logged user email variable
    );
    const projectId = row._id
    const personId = currentEmployee._id

    if (isUserAssigned.isRead === false) {
      try {
        await dispatch(setPersonReadTrue({ projectId, personId }));
      } catch (error) {
        console.error("Error updating Notes:", error);
      } finally {
        handlerefresh()
      }
    }

  };

  return (
    <div>
      <>
        {isLoading ? <AdminLoader isLoading={isLoading} /> : <> </>}
        <div className="pt-2">
          <div className="flex justify-between items-center p-2 bg-white rounded-t">
            <div className="font-semibold ">Project Completed</div>
            <div className="flex gap-2 p-1 align-middle items-center bg-[#e0e7ff] rounded-full">
              <MdSearch className=" w-5 h-5 text-gray-500" />
              <input
                type="text"
                value={searchQuery}
                onChange={handleSearchInputChange}
                placeholder="Search"
                className="bg-[#e0e7ff] outline-none w-[80%]"
              />
            </div>
          </div>
          <div
            ref={ProjectCompleteOpref}
            className="w-full bg-white h-full  min-h-[20vh] max-h-[80vh] overflow-auto pb-5">
            <div className={`${rowId ? "min-w-[1500px]" : ""}`}>
              <div className="flex w-[100%] bg-[#E8E8E8] text-black text-xs  text-center z-[2499]">
                <div className={`font-semibold flex ${rowId ? "w-[50%]" : "w-[80%]"}`}>
                  <div className="w-[10%] border pl-3 flex justify-start items-center h-12">
                    Sr. No
                  </div>

                  <div className="w-[20%] relative border p-2 flex justify-start items-center h-12">
                    <p className="w-[75%] text-start break-words whitespace-normal">Group</p>
                    <div className="w-[25%] flex flex-col -mt-1">
                      <ArrowDropUp
                        className="cursor-pointer"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("AssignedGroup", "az")}
                      />
                      <ArrowDropDown
                        className="cursor-pointer -mt-2"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("AssignedGroup", "za")}
                      />
                    </div>
                  </div>

                  <div className="w-[20%] relative border p-2 flex justify-start items-center h-12">
                    <p className="w-[75%] text-start break-words whitespace-normal">Project</p>
                    <div className="w-[25%] flex flex-col -mt-1">
                      <ArrowDropUp
                        className="cursor-pointer"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("ProjectName", "az")}
                      />
                      <ArrowDropDown
                        className="cursor-pointer -mt-2"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("ProjectName", "za")}
                      />
                    </div>
                  </div>
                  <div className="w-[20%] relative border flex justify-center items-center h-12">
                    <p className="text-start break-words whitespace-normal ">Date Requested</p>
                    <div className="absolute right-0  flex flex-col justify-end ">
                      <ArrowDropUp
                        className="cursor-pointer"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("DateRequested", "az")}
                      />
                      <ArrowDropDown
                        className="cursor-pointer -mt-2"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("DateRequested", "za")}
                      />
                    </div>
                  </div>

                  <div className="w-[18%] relative border p-2 flex justify-center items-center h-12">
                    <p className=" text-start break-words whitespace-normal">Due Date</p>

                    <div className=" absolute right-2 flex flex-col -mt-1">
                      <ArrowDropUp
                        className="cursor-pointer"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("ProjectDueDate", "az")}
                      />
                      <ArrowDropDown
                        className="cursor-pointer -mt-2"
                        sx={{ fontSize: "20px" }}
                        onClick={() => sortAlphabetically("ProjectDueDate", "za")}
                      />
                    </div>
                  </div>

                  <div className="w-[12%] border p-2 flex justify-center h-12 items-center">
                    Attachment
                  </div>
                </div>
                {rowId ? (
                  <div className={`flex font-semibold flex-col h-12 ${rowId ? "w-[50%]" : "w-[20%]"}`}>
                    <div className="w-full h-[50%] border break-words text-wrap flex justify-center items-center" >
                      Task Details
                    </div>
                    <div className="w-full h-[50%] border break-words text-wrap flex ">
                      <div
                        onClick={() => setShowListState("tasktable")}
                        className={`w-[50%] border-r-2 ${showListState === "tasktable" ? "bg-blue-500 text-white" : "text-black"} p-2 cursor-pointer flex justify-center items-center`}>
                        {clickedProject?.TypeService?.toLowerCase().includes("hardware") ? "Part List" : "Effort Expenses"}
                        {/* {clickedProject.TypeService === "Hardware" ? "Part List" : "Effort Expenses"} */}
                      </div>
                      <div
                        onClick={() => setShowListState("otherexpenses")}
                        className={` w-[50%] ${showListState === "otherexpenses" ? "bg-blue-500 text-white" : "text-black"} p-2 cursor-pointer flex justify-center items-center`}>
                        Other Expenses
                      </div>
                    </div>
                  </div>
                ) : (
                  <div className="font-semibold flex w-[20%] h-12 justify-center items-center ">
                    <div className="w-full h-full bg-[#E8E8E8] text-black border p-2 break-words text-wrap flex justify-center items-center">
                      Task Details
                    </div>
                  </div>
                )}

              </div>

              <div
                className="w-[100%]">
                {paginatedProjects?.map((row, index) => {
                  const matchedRowWorkEntries =
                    projectTrackingWorkEntries.filter(
                      (entry) => entry.projectid === row._id && entry?.taskownerid === loggedEmp?._id
                    );
                  const matchedRowDescription =
                    descriptionProjectTracking.filter(
                      (entry) => entry.projectid === row._id && entry?.taskownerid === loggedEmp?._id
                    );
                  const matchedHardwareParts =
                    hardwareProjectTracking.filter(
                      (entry) => entry.projectid === row._id && entry?.taskownerid === loggedEmp?._id
                    );

                  const taskKey = `${row?._id}_${row.ProjectName}-tasktable`
                  const expenseKey = `${row?._id}_${row.ProjectName}-otherexpenses`
                  const isUserAssigned = row.Assignedperson?.find(
                    person => person.email === LoggedUser // replace with your actual logged user email variable
                  );
                  return (
                    <div
                      className={`flex text-xs ${isUserAssigned.isRead === false ? " font-bold" : ""} cursor-pointer hover:bg-gray-100 w-full  border-gray-300`}
                      key={index}
                    >
                      <div className={` ${rowId ? "w-[50%]" : "w-[80%]"} flex `}>
                        <div onClick={() => {
                          const isOpening = rowId !== row?._id;
                          setRowId(rowId === row._id ? null : row._id)
                          setClickedProject(clickedProject === row ? null : row)
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className="w-[10%] border-b text-center flex justify-start align-middle items-center pl-3">
                          {startIdx + index + 1}{" "}
                        </div>
                        <div onClick={() => {
                          const isOpening = rowId !== row?._id;
                          setRowId(rowId === row._id ? null : row._id)
                          setClickedProject(clickedProject === row ? null : row)
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className="w-[20%] border-b flex justify-start align-middle items-center p-2 break-words text-wrap">
                          {getDisplayGroupName(row)}
                        </div>
                        <div onClick={() => {
                          const isOpening = rowId !== row?._id;
                          setRowId(rowId === row._id ? null : row._id)
                          setClickedProject(clickedProject === row ? null : row)
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className="w-[20%] border-b flex justify-start align-middle items-center text-left p-2 break-words whitespace-normal overflow-hidden text-ellipsis line-clamp-2 leading-snug text-xs">
                          {row.ProjectName}
                        </div>
                        <div onClick={() => {
                          const isOpening = rowId !== row?._id;
                          setRowId(rowId === row._id ? null : row._id)
                          setClickedProject(clickedProject === row ? null : row)
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className="w-[20%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2 ">
                          {row.DateRequested &&
                            !isNaN(new Date(row.DateRequested))
                            ? formatDateByCountry(
                              row.DateRequested
                            )
                            : ""}
                        </div>
                        <div onClick={() => {
                          const isOpening = rowId !== row?._id;
                          setRowId(rowId === row._id ? null : row._id)
                          setClickedProject(clickedProject === row ? null : row)
                          if (isOpening) {
                            handleleadread(row)
                          }
                        }}
                          className="w-[18%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2 ">
                          {row.ProjectDueDate &&
                            !isNaN(new Date(row.ProjectDueDate))
                            ? formatDateByCountry(
                              row.ProjectDueDate
                            )
                            : ""}
                        </div>
                        <div className="w-[12%] border-b flex-shrink-0 p-2 truncate flex justify-center align-middle items-center text-xs line-clamp-2 ">
                          <FileUploadOP project={row} leads={leads} employees={employees} isViewOnly={isViewOnly} />
                        </div>
                      </div>
                      <div className={`flex ${rowId ? "w-[50%]" : "w-[20%]"} border-b `}>
                        {rowId === row._id ? (
                          <>
                            <div
                              onClick={(e) => e.stopPropagation()}
                              className="w-full pt-2">
                              <ShowCompletedTasksOP
                                row={row}
                                loggedEmp={loggedEmp}
                                taskKey={taskKey}
                                expenseKey={expenseKey}
                                matchedRowDescription={matchedRowDescription}
                                projectTrackingWorkEntries={matchedRowWorkEntries}
                                matchedHardwareParts={matchedHardwareParts}
                                showListState={showListState}
                                isViewOnly={isViewOnly}
                              />
                            </div>
                          </>
                        ) : (
                          <div onClick={() => {
                            const isOpening = rowId !== row?._id;
                            setRowId(rowId === row._id ? null : row._id)
                            setClickedProject(clickedProject === row ? null : row)
                            if (isOpening) {
                              handleleadread(row)
                            }
                          }}
                            className="flex w-full justify-center items-center">
                            Multiple
                          </div>
                        )}

                      </div>
                    </div>
                  );
                })}
                {paginatedProjects?.length === 0 && (
                  <div className="noDataAvailable p-2">No Result Found</div>
                )}
              </div>
            </div>
          </div>
          <div
            className={`pagination flex justify-between  text-xs items-center bg-white pb-2 pl-2 rounded-md ${paginatedProjects?.length > 0 ? "p-1" : ""
              } `}
          >
            <div>
              {totalItems > 0 ? (
                <>
                  Showing {startIdx + 1} to {Math.min(endIdx, totalItems)} of{" "}
                  {totalItems} Entries
                </>
              ) : (
                <>
                  {paginatedProjects?.length > 0 && (
                    <>Showing {paginatedProjects?.length} Entries</>
                  )}
                </>
              )}
            </div>
            {totalPages > 1 && (
              <div className="flex">
                <button
                  onClick={() => setCurrentPage(1)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === 1}
                  title="First Page"
                >
                  <KeyboardDoubleArrowLeftIcon className="w-5 h-5" />
                </button>
                <button
                  onClick={() =>
                    setCurrentPage((prev) => Math.max(prev - 1, 1))
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === 1}
                >
                  <ChevronRightIcon className="w-5 h-5 rotate-180" />
                </button>

                {Array.from({ length: 3 }, (_, index) => {
                  const pageNumber = currentPage - 1 + index;
                  if (pageNumber >= 1 && pageNumber <= totalPages) {
                    return (
                      <button
                        key={pageNumber}
                        onClick={() => setCurrentPage(pageNumber)}
                        className={`px-4 py-2 mx-2 border rounded ${currentPage === pageNumber
                          ? "bg-gray-300"
                          : ""
                          }`}
                      >
                        {pageNumber}
                      </button>
                    );
                  }
                  return null;
                })}

                <button
                  onClick={() =>
                    setCurrentPage((prev) =>
                      Math.min(prev + 1, totalPages)
                    )
                  }
                  className="px-2 py-2 mx-2 border rounded"
                  disabled={currentPage === totalPages}
                >
                  <ChevronRightIcon className="w-5 h-5" />
                </button>

                <button
                  onClick={() => setCurrentPage(totalPages)}
                  className="px-2 py-2 mx-1 border rounded"
                  disabled={currentPage === totalPages}
                  title="Last Page"
                >
                  <KeyboardDoubleArrowRightIcon className="w-5 h-5" />
                </button>
              </div>
            )}
          </div>
        </div>
      </>
    </div>
  );
};

export default ProjectCompletedOpDash;
